import ApiHelpers from '@/data/dao/base/ApiHelpers';
import {DataloggerFirmware, DataloggerOtaRequest, DataloggerOverview, DataloggerWifiRequest} from '@/data/models/datalogger';

export default class DataloggerDao {
  static getOverview(meterId: string): Promise<DataloggerOverview> {
    return ApiHelpers.get<DataloggerOverview>(`/admin/datalogger/meter/${meterId}`);
  }

  static requestWifi(meterId: string, ssid: string, password: string): Promise<DataloggerWifiRequest> {
    return ApiHelpers.post<DataloggerWifiRequest>(`/admin/datalogger/meter/${meterId}/wifi`, {ssid, password});
  }

  static cancelWifi(meterId: string): Promise<any> {
    return ApiHelpers.delete(`/admin/datalogger/meter/${meterId}/wifi/pending`);
  }

  static requestOta(meterId: string, firmwareId: string): Promise<DataloggerOtaRequest> {
    return ApiHelpers.post<DataloggerOtaRequest>(`/admin/datalogger/meter/${meterId}/ota`, {firmwareId});
  }

  static cancelOta(meterId: string): Promise<any> {
    return ApiHelpers.delete(`/admin/datalogger/meter/${meterId}/ota/pending`);
  }

  static getFirmwares(): Promise<DataloggerFirmware[]> {
    return ApiHelpers.get<DataloggerFirmware[]>('/admin/datalogger/firmwares');
  }

  /** Dépôt du .bin de l'application (Croquis → Exporter les binaires compilés), envoyé tel quel. */
  static uploadFirmware(file: File, version: string, comment: string): Promise<DataloggerFirmware> {
    const query = new URLSearchParams({version, filename: file.name, comment: comment || ''});
    return ApiHelpers.doAuthRequest(`/admin/datalogger/firmwares?${query.toString()}`)
      .then(request => request.content('application/octet-stream').body(file).post().json());
  }

  static deleteFirmware(firmwareId: string): Promise<any> {
    return ApiHelpers.delete(`/admin/datalogger/firmwares/${firmwareId}`);
  }
}
